import { SagaIterator } from "redux-saga";
import { call, put } from "redux-saga/effects";
import { HttpResponseTypeEnum } from "../core/enumerations/ServerRequestStatusEnum";
import { createProjectRedux } from "../redux/create-project-redux/CreateProjectRedux";

export function* getUsersListBasedOnSkillId(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.getUsersListBasedOnSkillId, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(createProjectRedux.actions.getUsersListBasedOnSkillIdSuccess(response.data));
        } else {
            yield put(createProjectRedux.actions.getUsersListBasedOnSkillIdFailure(response.data));
        }
    } catch (error: any) {
        yield put(createProjectRedux.actions.getUsersListBasedOnSkillIdFailure(error));
    }
}

export function* createProject(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.createProject, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(createProjectRedux.actions.createProjectSuccess({ data: { ...response.data, ...action.payload } }));
        } else {
            yield put(createProjectRedux.actions.createProjectFailure(response.data));
        }
    } catch (error: any) {
        yield put(createProjectRedux.actions.createProjectFailure(error));
    }
}

export function* uploadProjectMedia(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.uploadProjectMedia, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(createProjectRedux.actions.uploadProjectMediaSuccess(response.data));
        } else {
            yield put(createProjectRedux.actions.uploadProjectMediaFailure(response.data));
        }
    } catch (error: any) {
        yield put(createProjectRedux.actions.uploadProjectMediaFailure(error));
    }
}


export function* getAllMyProjects(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.getAllMyProjects, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(createProjectRedux.actions.getAllMyProjectsSuccess(response.data));
        } else {
            yield put(createProjectRedux.actions.getAllMyProjectsFailure(response.data));
        }
    } catch (error: any) {
        yield put(createProjectRedux.actions.getAllMyProjectsFailure(error));
    }
}

export function* getAllMyCollaboratedProjects(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.getAllMyCollaboratedProjects, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(createProjectRedux.actions.getAllMyCollaboratedProjectsSuccess(response.data));
        } else {
            yield put(createProjectRedux.actions.getAllMyCollaboratedProjectsFailure(response.data));
        }
    } catch (error: any) {
        yield put(createProjectRedux.actions.getAllMyCollaboratedProjectsFailure(error));
    }
}

export function* updateProject(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.updateProject, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(createProjectRedux.actions.updateProjectSuccess(response.data));
        } else {
            yield put(createProjectRedux.actions.updateProjectFailure(response.data));
        }
    } catch (error: any) {
        yield put(createProjectRedux.actions.updateProjectFailure(error));
    }
}

export function* saveProject(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.saveProject, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(createProjectRedux.actions.saveProjectSuccess(response.data));
        } else {
            yield put(createProjectRedux.actions.saveProjectFailure(response.data));
        }
    } catch (error: any) {
        yield put(createProjectRedux.actions.saveProjectFailure(error));
    }
}

export function* getAllSavedProjects(api: any, action: any): SagaIterator {
    try {
        const response = yield call(api.getAllSavedProjects, action.payload);
        if (
            response.status === HttpResponseTypeEnum.Success ||
            response.status === HttpResponseTypeEnum.userCreated
        ) {
            yield put(createProjectRedux.actions.getAllSavedProjectsSuccess(response.data));
        } else {
            yield put(createProjectRedux.actions.getAllSavedProjectsFailure(response.data));
        }
    } catch (error: any) {
        yield put(createProjectRedux.actions.getAllSavedProjectsFailure(error));
    }
}
